/* convert value to string or default to '--' */
export const getValueForVehicleDetailCard = (value: string | number | undefined | null): string => {
  if (value === undefined || value === null) return '--'
  if (typeof value === 'number') return value.toString()
  return value
}
